import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lightbulb, ChevronDown, ChevronRight } from "lucide-react";

export interface IdeaItem {
  title: string;
  body: string;
}

const DEFAULT_IDEAS: IdeaItem[] = [
  {
    title: "Automate your payment",
    body: "Set up a recurring transfer in online banking so following through on your commitment doesn't depend on memory.",
  },
  {
    title: "Identify an accountability partner",
    body: "Share this commitment with a spouse, family member, or advisor who can quietly check in with you.",
  },
  {
    title: "Plan a Family Financial Forum™",
    body: "Use this loan as a teaching moment — schedule a short family conversation about purpose and stewardship.",
  },
  {
    title: "Reserve your Family Financing Margin™",
    body: "Decide in advance where redirected dollars will go after the loan is repaid so they don't quietly drift away.",
  },
];

export function IdeasPanel({ ideas = DEFAULT_IDEAS }: { ideas?: IdeaItem[] }) {
  const [open, setOpen] = useState(false);
  return (
    <Card>
      <CardHeader className="pb-2">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="flex items-center justify-between w-full text-left"
        >
          <CardTitle className="text-base font-semibold flex items-center gap-2">
            {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
            <Lightbulb className="h-4 w-4 text-[hsl(var(--status-attention))]" />
            Ideas to Strengthen Your Plan
          </CardTitle>
          <span className="text-xs text-muted-foreground">{ideas.length} suggestions</span>
        </button>
      </CardHeader>
      {open && (
        <CardContent>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {ideas.map((idea, i) => (
              <li key={i} className="flex items-start gap-3 rounded-md border bg-card/50 p-3">
                <Lightbulb className="h-4 w-4 mt-0.5 text-[hsl(var(--status-attention))] shrink-0" />
                <div className="min-w-0">
                  <div className="text-sm font-medium leading-tight">{idea.title}</div>
                  <div className="text-xs text-muted-foreground mt-1">{idea.body}</div>
                </div>
              </li>
            ))}
          </ul>
        </CardContent>
      )}
    </Card>
  );
}